import { Chakra } from "@airhelp/react-ui-components";
import type { OptionalInputLabelProps } from "./OptionalInputLabel.d";

const { Text, FormLabel } = Chakra;

const OptionalInputLabel = ({ label, optionalText }: OptionalInputLabelProps) => (
  <FormLabel>
    {label}&nbsp;
    <Text fontSize="sm" as="span" color="greyscale.500">
      {optionalText}
    </Text>
  </FormLabel>
);

export default OptionalInputLabel;
